import { NavigationItemFlatTreeConfig } from '@/app/platform/platform-shared/navigation-item-tree/types';
import { FlatTreeControl } from '@angular/cdk/tree';
import { NavigationItemNode } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-dragger';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Directive, Input } from '@angular/core';
import { EgiAppData } from '@/app/platform/platform-shared/models/types';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';

@Directive()
export abstract class NavigationItemTreeComponent<
  T extends NavigationItemData,
  TApp extends EgiAppData
> {
  @Input('app') set appInput(app: TApp) {
    const previousApp = this.app?.clone();

    this.app = app;
    this.fillDataSource(app);
    if (!this.app.is(previousApp)) {
      this.onAppChange();
      if (this.onAppInputChange) {
        this.onAppInputChange();
      }
    }
  }

  protected fillDataSource(app: TApp) {
    this.dataSource.data = [(app.rootNavigationItem as T).clone()];
  }

  protected app: TApp;

  public readonly treeControl: FlatTreeControl<NavigationItemNode<T>, string>;
  protected readonly dataSource: MatTreeFlatDataSource<T, NavigationItemNode<T>, string>;
  private openedApps: EgiAppData[] = [];

  protected constructor(
    navigationItemFlatTreeConfig: NavigationItemFlatTreeConfig<T>,
    trackNodeCollapsedBy: (node: NavigationItemNode<T>) => string,
    private readonly onAppInputChange?: () => any,
    private readonly cacheCondition?: () => boolean
  ) {
    const { getLevel, isExpandable, transformer, getChildren } = navigationItemFlatTreeConfig;

    this.treeControl = new FlatTreeControl<NavigationItemNode<T>, string>(getLevel, isExpandable, {
      trackBy: trackNodeCollapsedBy
    });
    const treeFlattener = new MatTreeFlattener<T, NavigationItemNode<T>, string>(
      transformer,
      getLevel,
      isExpandable,
      getChildren
    );
    this.dataSource = new MatTreeFlatDataSource<T, NavigationItemNode<T>, string>(
      this.treeControl,
      treeFlattener
    );
  }

  protected onAppChange() {
    if (this.cacheCondition && !this.cacheCondition()) {
      return;
    }
    const app = this.app;
    if (!this.openedApps.some(a => a.is(app))) {
      if (app) {
        this.openedApps.push(app);
        this.treeControl.expandAll();
      }
    }
  }
}
